exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-header {\n    color: #fff;\n    background-color: #4dbd74;\n    border-top-left-radius: calc(0.3rem - 1px);\n    border-top-right-radius: calc(0.3rem - 1px);\n}\n.modal-content {\n    border: 0px !important; \n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/shared/components/success-modal/success-modal.component.css
// module id = ../../../../../src/app/views/shared/components/success-modal/success-modal.component.css
// module chunks = main